import { SmallContainer } from './SmallContainer'

export function MainContent(props: { children: React.ReactNode }) {
  return (
    <main className="main-content">
      <SmallContainer>{props.children}</SmallContainer>
    </main>
  )
}
